import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LESSON_FEATURE_KEY,
  LessonState,
  lessonAdapter,
} from './lesson.reducer';

export const selectLessonState =
  createFeatureSelector<LessonState>(LESSON_FEATURE_KEY);

const { selectAll, selectEntities } = lessonAdapter.getSelectors();

export const selectAllLessons = createSelector(
  selectLessonState,
  (state: LessonState) => selectAll(state),
);

export const selectLessonEntities = createSelector(
  selectLessonState,
  selectEntities,
);
